export default {
  Model: {},
  Actions: {
    FETCH_WORKSPACE_MEETINGS_SUCCESS: 'workspace_meetings/FETCH_WORKSPACE_MEETINGS_SUCCESS',
    FETCH_WORKSPACE_MEETING_SNAPSHOT_SUCCESS: 'workspace_meetings/FETCH_WORKSPACE_MEETING_SNAPSHOT_SUCCESS',
  },
  State: {},
};
